var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C24 14 -2.23141 13.9999 0.153267 14C2.53794 14.0001 4.92261 14.0001 8.49962 11.0001C10.872 9.01036 16.9158 3.94146 20.7174 0.753063C22.0189 -0.338486 24 0.589052 24 2.28768V14Z",
    fill: "currentColor"
  })));
};
export default __webpack_public_path__ + "static/media/beak.273a15b5.svg";
export { SvgComponent as ReactComponent };